// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M13 3.05493V4.83987L15.1835 3.57924C14.4922 3.31778 13.7604 3.13899 13 3.05493ZM17.255 4.69266L13 7.14927V11.1908L19.693 7.32655C19.0642 6.29365 18.2332 5.39736 17.255 4.69266ZM20.5386 9.14773L13 13.5002V17.5417L20.9503 12.9516C20.9832 12.6389 21 12.3214 21 12C21 11.0031 20.8379 10.044 20.5386 9.14773ZM20.2126 15.6869L13 19.8511V20.9451C16.2239 20.5887 18.9345 18.5295 20.2126 15.6869ZM1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-contrast-1-filled')
export default class Contrast1FilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'contrast-1-filled',
    }
  }
}
